import React, {createElement, useContext} from 'react';
import {Icon, Activities, DateContext, UI} from 'components';
import {get, kebabCase, openPopup, useNamedSelector} from 'helpers';
import {toggle} from 'store/activities';
import css from './checkbox.module.scss';

export function Checkbox(props) {
  return createElement(props.type == 'activity' ? OneTimeCheckbox : RecurringCheckbox, props);
}

function OneTimeCheckbox(props) {
  return (
    <UI.Checkbox
      className={css(props)}
      checked={props.status == 'Completed'}
      onClick={() => toggle(props)}
    />
  );
}

function RecurringCheckbox({activity, type, retroperspective, perDay, subtask, className}) {
  const contextDate = useContext(DateContext);
  if (!contextDate) {
    return null;
  }
  const occurance = useNamedSelector(subtask ? 'calendar.subtaskOccurance' : 'calendar.occurance', { date: contextDate })(activity);
  const status = get(occurance, 'status', occurance === false ? 'disabled' : 'muted');
  const onClick = openPopup(Activities.StatusMenu, {
    activity,
    contextDate,
    occurance,
    status,
    subtask,
    type,
    retroperspective,
    id: activity.id
  });
  return (
    <UI.Checkbox className={css('checkbox', className, retroperspective && 'has-caption', kebabCase(status))} checked={status == 'Completed'} onClick={onClick}>
      <Icon name={Activities.StatusMenu.statuses[status]?.icon} />
      { Boolean(occurance && occurance.count && perDay > 1) &&
        <span className={css.caption}>{ occurance.count }/{ perDay }</span>
      }
      { retroperspective &&
        <span className={css.caption}>
          { contextDate.date() }
          <small>{ contextDate.format('MMM') }</small>
        </span>
      }
    </UI.Checkbox>
  );
}
